

import axios from "axios";
import SignOut from "../components/SignIn/SignOut";
import { getUserData } from "./signIn";

const store = require("store");

let allUsersPromise = null;

export async function fetchAllImpersonateUsers() {
  if (!allUsersPromise) {
    allUsersPromise = axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3001 + "/impersonate/users",
      headers: {
        Authorization: "Bearer " + store.get("access_token"),
      },
    })
      .then((result) => {
        const payload = result.data?.data ?? result.data;
        return Array.isArray(payload) ? payload : [];
      })
      .catch((err) => {
        allUsersPromise = null;
        throw err;
      });
  }
  return allUsersPromise;
}

export async function searchImpersonateUsers(_q) {
  return { data: await fetchAllImpersonateUsers() };
}

export async function startImpersonate(username) {
  const result = await axios({
    method: "post",
    url: process.env.REACT_APP_API_URL_3001 + "/impersonate/start",
    headers: {
      Authorization: "Bearer " + store.get("access_token"),
      "Content-Type": "application/json",
    },
    data: { username },
  });
  return result.data;
}

export async function refreshProfile() {
  try {
    const token = store.get("access_token");
    if (!token) return;

    const userInfoRes = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3001 + "/attr/userInfo",
      headers: { Authorization: "Bearer " + token },
    });
    const infoPayload = userInfoRes.data?.data ?? userInfoRes.data;
    
    const infoRows = Array.isArray(infoPayload) ? infoPayload : [];
    if (infoRows.length > 0) {
      store.set("grade_code", infoRows[0].grade_code);
      store.set("employee_id", infoRows[0].employee_id);
    }
    const simulateSelect = !!(infoRows[0]?.simulate_select);
    store.set("simulate_select", simulateSelect);

    const userData = await getUserData("Bearer " + token);
    const profile = userData?.data || userData || {};
    if (profile.company) store.set("company", profile.company);
    if (profile.email != null) store.set("email", profile.email);
    if (profile.fullname_chi != null) store.set("fullname_chi", profile.fullname_chi);
    if (profile.fullname_eng != null) store.set("fullname_eng", profile.fullname_eng);
    if (profile.section) store.set("section", profile.section);
    if (profile.user_seq != null) store.set("user_seq", profile.user_seq);
    if (profile.username) store.set("username", profile.username);
  } catch (error) {
    if (error?.response?.status === 401) {
      SignOut();
      return;
    }
    throw error;
  }
}

export async function switchToUser(username) {
  const u = String(username || "").trim();
  if (!u) throw new Error("請選擇用戶");
  await startImpersonate(u);
  if (!store.get("real_username")) {
    store.set("real_username", store.get("username"));
    store.set("real_fullname_eng", store.get("fullname_eng"));
    store.set("real_fullname_chi", store.get("fullname_chi"));
  }
  store.set("impersonate_username", u);
  await refreshProfile();
}

export async function switchBackToSelf() {
  store.remove("impersonate_username");
  await refreshProfile();
  
  if (store.get("real_username")) {
    store.set("username", store.get("real_username"));
  }
  if (store.get("real_fullname_eng") != null) {
    store.set("fullname_eng", store.get("real_fullname_eng"));
  }
  if (store.get("real_fullname_chi") != null) {
    store.set("fullname_chi", store.get("real_fullname_chi"));
  }
}
